export const add = (a, b) => a + b;
export const subtract = (a, b) => a - b;
export const multiply = (a, b) => a * b;
export const divide = (a, b) => a / b;



/** WEBPACK FOOTER **
 ** ./src/lib/binaryOps.js
 **/